import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import LiberationSansRegular from "./LiberationSans-Regular.woff2";

export const LiberationFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LiberationSansRegular,
  },
];
